"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIME = exports.TimeType = exports.Type = void 0;
/** @jsx jsx */
var react_1 = __importStar(require("react"));
var react_2 = require("@emotion/react");
var styles_1 = require("./styles");
var layout_1 = require("../../layout");
var icons_1 = require("../../../icons");
var Picker_1 = __importDefault(require("./Picker"));
var utils_1 = require("./utils");
var withLabel_1 = require("../../InputLabel/withLabel");
var variables_1 = require("../../../style/variables");
var Type;
(function (Type) {
    Type["HOUR"] = "hours";
    Type["MINUTE"] = "minutes";
    Type["SECOND"] = "seconds";
    Type["AM_PM"] = "amPm";
})(Type = exports.Type || (exports.Type = {}));
var TimeType;
(function (TimeType) {
    TimeType["START"] = "start";
    TimeType["END"] = "end";
})(TimeType = exports.TimeType || (exports.TimeType = {}));
exports.DEFAULT_TIME = (_a = {},
    _a[Type.HOUR] = null,
    _a[Type.MINUTE] = null,
    _a[Type.SECOND] = null,
    _a[Type.AM_PM] = null,
    _a);
var getContainerWidth = function (size, range, use12Hours) {
    if (size === 'sm') {
        if (range) {
            return use12Hours ? 224 : 188;
        }
        return use12Hours ? 120 : 102;
    }
    if (range) {
        return use12Hours ? 260 : 216;
    }
    return use12Hours ? 140 : 118;
};
var TimePicker = function (_a) {
    var use12Hours = _a.use12Hours, _b = _a.startPlaceholder, startPlaceholder = _b === void 0 ? 'Start Time' : _b, _c = _a.endPlaceholder, endPlaceholder = _c === void 0 ? 'End Time' : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, disabled = _a.disabled, readOnly = _a.readOnly, props = __rest(_a, ["use12Hours", "startPlaceholder", "endPlaceholder", "size", "disabled", "readOnly"]);
    var startTime = react_1.useMemo(function () { var _a; return utils_1.stringToTime(props.range ? (_a = props.value) === null || _a === void 0 ? void 0 : _a[0] : props.value, use12Hours); }, [props.range, props.value, use12Hours]);
    var endTime = react_1.useMemo(function () { var _a; return utils_1.stringToTime(props.range ? (_a = props.value) === null || _a === void 0 ? void 0 : _a[1] : '', use12Hours); }, [props.range, props.value, use12Hours]);
    var handleOnChange = function (type) { return function (time) {
        var _a, _b, _c, _d, _e;
        var timeString = utils_1.getTimeString(time, false);
        if (type === TimeType.START) {
            if (props.range) {
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, [timeString, ((_b = props.value) === null || _b === void 0 ? void 0 : _b[1]) || '']);
            }
            else {
                (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, timeString);
            }
        }
        else if (props.range) {
            (_d = props.onChange) === null || _d === void 0 ? void 0 : _d.call(props, [((_e = props.value) === null || _e === void 0 ? void 0 : _e[0]) || '', timeString]);
        }
    }; };
    var containerStyle = react_1.useMemo(function () { return [
        styles_1.styles.container,
        react_2.css({
            width: getContainerWidth(size, props.range, use12Hours),
            minWidth: getContainerWidth(size, props.range, use12Hours),
            maxWidth: getContainerWidth(size, props.range, use12Hours),
            height: size === 'sm' ? 28 : 36,
            minHeight: size === 'sm' ? 28 : 36,
            maxHeight: size === 'sm' ? 28 : 36,
            padding: size === 'sm' ? '5px 10px' : '8px 12px',
            borderRadius: "var(" + (size === 'sm' ? variables_1.BorderRadius.xs : variables_1.BorderRadius.sm) + ")",
        }),
    ]; }, [props.range, use12Hours, size]);
    return (react_2.jsx(react_1.Fragment, null,
        react_2.jsx(react_2.Global, { styles: styles_1.pickerStyle }),
        react_2.jsx(layout_1.Flex, { gap: 8, css: [
                containerStyle,
                disabled ? styles_1.styles.disabledContainer : undefined,
                readOnly ? styles_1.styles.readOnlyContainer : undefined,
            ], alignItems: "center" },
            react_2.jsx(icons_1.Clock, { size: 16 }),
            react_2.jsx(layout_1.Flex, { alignItems: "center", css: { flex: 1 } },
                react_2.jsx(Picker_1.default, { time: startTime, placeholder: startPlaceholder, onChange: handleOnChange(TimeType.START), use12Hours: use12Hours, range: props.range, disabled: disabled, size: size }),
                props.range ? (react_2.jsx(react_1.default.Fragment, null,
                    react_2.jsx(layout_1.Flex, { css: styles_1.styles.separator },
                        react_2.jsx(icons_1.Minus, { size: 16, color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")" })),
                    react_2.jsx(Picker_1.default, { time: endTime, placeholder: endPlaceholder, onChange: handleOnChange(TimeType.END), use12Hours: use12Hours, range: props.range, disabled: disabled, size: size }))) : null))));
};
exports.default = Object.assign(TimePicker, {
    Labeled: withLabel_1.withLabel(TimePicker),
});
